import * as action_types from './action_types';
import {console_log} from "../utils/helper";

export const checkAccess = (data) => {
    return {
        type: action_types.HAS_ACCESS,
        data: data
    }
};

export const addUid = (data) => {
    return {
        type: action_types.ADD_UID,
        data: data
    }
};

export const changeLangAction = (data) => {
    return {
        type: action_types.CHANGE_LANGUAGE,
        data: data
    }
};


// WEBPACK FOOTER //
// ./src/actions/WelcomeActions.js